import { createApp } from 'vue'
import App from './App.vue'
import PrivacyVideo from './components/PrivacyVideo.vue'
import router from './router'
import store from './store'

import axios from "@/axios/axios";
import { installClickTracking } from "@/utils/tracking";

import "@/css/webflow.css";
import "@/css/urbo-sk-209904.webflow.css";
import "@/css/normalize.css";
import "@/css/app.scss";

const app = createApp(App);
app.component("PrivacyVideo", PrivacyVideo);
installClickTracking();

app.config.globalProperties.$api = axios;
store.$api = axios;

app
  .use(store)
  .use(router)
  .mount('#app')
